import React from 'react';
import { Delete, X, Hash } from 'lucide-react';

const CalculatorKeyboard = ({ onKeyTap, onHide, onMemoryClear }) => {
  const keys = [
    ['M+', 'M-', 'MR', 'MC'],
    ['C', '÷', '×', '⌫'],
    ['7', '8', '9', '-'],
    ['4', '5', '6', '+'],
    ['1', '2', '3', '='],
    ['%', '0', '.', 'OK']
  ];

  return (
    <div style={styles.container}>
      <div style={styles.grid}>
        {keys.map((row, i) => (
          <div key={i} style={styles.row}>
            {row.map((key) => {
              const isOperator = ['+', '-', '×', '÷', '=', '%'].includes(key);
              const isAction = ['C', '⌫', 'OK', 'OK'].includes(key);
              const isMemory = ['M+', 'M-', 'MR', 'MC'].includes(key);

              let bg = '#FFFFFF';
              let color = '#1E293B';

              if (isOperator) { bg = '#F1F5F9'; color = '#3B82F6'; }
              if (key === '=') { bg = '#3B82F6'; color = '#FFFFFF'; }
              if (key === 'OK') { bg = '#10B981'; color = '#FFFFFF'; }
              if (key === '⌫') { color = '#EF4444'; }
              if (key === 'C') { color = '#EF4444'; }
              if (isMemory) { bg = '#F8FAFC'; color = '#6366F1'; }

              return (
                <button
                  key={key}
                  type="button"
                  style={{...styles.key, background: bg, color: color}}
                  onClick={() => key === 'OK' ? onHide() : onKeyTap(key)}
                >
                  {key === '⌫' ? <Delete size={20} /> : key}
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: '#F1F5F9',
    padding: '12px',
    borderTop: '1px solid #E2E8F0',
    borderBottomLeftRadius: '28px',
    borderBottomRightRadius: '28px',
  },
  grid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  row: {
    display: 'flex',
    gap: '8px',
  },
  key: {
    flex: 1,
    height: '48px',
    borderRadius: '12px',
    border: 'none',
    fontSize: '16px',
    fontWeight: '700',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.1s active',
    userSelect: 'none',
  },
};

export default CalculatorKeyboard;
